// Task 06: thin async wrapper quanh engine createMemoryStorage() cho Vitest/SSR.
// KHÔNG viết store mới — mọi logic lưu trữ nằm trong engine adapter.
import { createMemoryStorage } from "@vninvestcharts/engine-react";
export class InMemoryStorageAdapter {
    store = createMemoryStorage();
    async getItem(key) {
        return this.store.getItem(key);
    }
    async setItem(key, value) {
        this.store.setItem(key, value);
    }
    async removeItem(key) {
        this.store.removeItem(key);
    }
    async clear() {
        this.store.clear();
    }
    async getAllKeys() {
        const keys = [];
        for (let i = 0; i < this.store.length; i += 1) {
            const key = this.store.key(i);
            if (key != null)
                keys.push(key);
        }
        return keys;
    }
    async getSize() {
        let size = 0;
        for (const key of await this.getAllKeys()) {
            size += (this.store.getItem(key) ?? "").length;
        }
        return size;
    }
}
